module.exports = __webpack_public_path__ + "img/nav-design-sets.bc60b9a.jpg";